<script setup lang="ts">
import { computed } from "vue";

import UserAvatarLabel from "~/components/dumb/UserAvatarLabel.vue";
import { useDataStore } from "~/stores";

const props = defineProps<{
  duids: string[];
  title?: string;
}>();

const dataStore = useDataStore();

const users = computed(() =>
  props.duids.map((duid) => dataStore.getUserByDuid(duid)).filter((user): user is NonNullable<typeof user> => !!user)
);
</script>

<template>
  <div class="flex w-full flex-col gap-2 p-2 text-xs text-md">
    <div v-if="title" class="font-semibold text-vlt">{{ title }}</div>
    <div class="flex flex-col gap-1">
      <UserAvatarLabel v-for="user in users" :key="user.duid" :user="user" />
    </div>
  </div>
</template>
